// extracted by mini-css-extract-plugin
export default {"icon":"pa","faq":"qa","summary":"ra","summaryInner":"sa","faqContent":"ta","blinking":"ua","gradientShift":"va","float":"wa","move":"xa","scroll":"ya"};